module.exports = __webpack_public_path__ + "img/logo.cd9947dd.png";